var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunExpressionboolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1356 12.6884V6.10855C17.1356 5.31277 18.02 4.8358 18.685 5.27296L23.6127 8.5126C24.2085 8.90429 24.2147 9.77587 23.6245 10.1759L18.6967 13.5162C18.0327 13.9663 17.1356 13.4906 17.1356 12.6884Z",
    fill: "#ADE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3675 11.5827C20.667 11.7803 20.667 12.2197 20.3675 12.4173L16.5254 14.9525C16.1929 15.1718 15.75 14.9334 15.75 14.5352L15.75 9.46485C15.75 9.06657 16.1929 8.82816 16.5254 9.04751L20.3675 11.5827Z",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09695 9.14382C7.7429 9.14382 8.73686 7.89098 8.74006 5.73366C8.74325 3.59233 7.73651 2.36506 6.09695 2.36506C4.45419 2.36506 3.45703 3.58913 3.45384 5.73366C3.44744 7.88459 4.4478 9.14062 6.09695 9.14382ZM6.09695 7.99645C5.34588 7.99645 4.86009 7.24219 4.86328 5.73366C4.86648 4.24751 5.34908 3.49964 6.09695 3.49964C6.84162 3.49964 7.32741 4.24751 7.32741 5.73366C7.33061 7.24219 6.84482 7.99645 6.09695 7.99645ZM12.5745 2.45455H11.2737L9.65332 3.48047V4.70774L11.1523 3.76811H11.1906V9H12.5745V2.45455Z",
    fill: "#272932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3782 14.4545H5.07741L3.45703 15.4805V16.7077L4.95597 15.7681H4.99432V21H6.3782V14.4545ZM10.5003 21.1438C12.1462 21.1438 13.1402 19.891 13.1434 17.7337C13.1466 15.5923 12.1398 14.3651 10.5003 14.3651C8.85751 14.3651 7.86035 15.5891 7.85716 17.7337C7.85076 19.8846 8.85112 21.1406 10.5003 21.1438ZM10.5003 19.9964C9.7492 19.9964 9.26341 19.2422 9.2666 17.7337C9.2698 16.2475 9.7524 15.4996 10.5003 15.4996C11.2449 15.4996 11.7307 16.2475 11.7307 17.7337C11.7339 19.2422 11.2481 19.9964 10.5003 19.9964Z",
    fill: "#272932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12L13 12",
    stroke: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunExpressionboolf);
export default __webpack_public_path__ + "static/media/Run Expression bool f.31b0cb660136a4efd12fe837a4d4b759.svg";
export { ForwardRef as ReactComponent };